import useAdBlockStore from "store/AdBlockStore";
import { LabelledInput } from "../../Fields";
import Button from "../../Button";
import { useState } from "react";
import { createModelNumberApi, createOriginApi, createVarietyApi } from "api";

const CreateManufacturerOriginVariety = () => {
    const currentProduct = useAdBlockStore((state) => state.currentProduct);
    const leftPanelView = useAdBlockStore((state) => state.leftPanelView);
    const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);

    const [inputValue, setInputValue] = useState("");

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleSubmit = async () => {
        const data = {
            ext_id: currentProduct?.brand?.ext_id,
            sub_cat_i: currentProduct?.brand?.sub_cat_i,
        }
        // Logic to handle submission based on leftPanelView
        if (leftPanelView === "model_number") {
            const res = await createModelNumberApi({
                ...data,
                model_number: inputValue
            });
            if (res.success) {
                updateCurrentProduct({
                    ...currentProduct,
                    model_number_ids: [...(currentProduct.model_number_ids || []), res.payload.ext_id],
                    brand: {
                        ...currentProduct.brand,
                        model_numbers: [...currentProduct.brand.model_numbers, res.payload]
                    }
                });
            }
        } else if (leftPanelView === "origin") {
            const res = await createOriginApi({
                ...data,
                origin_nm: inputValue
            });
            if (res.success) {
                updateCurrentProduct({
                    ...currentProduct,
                    brand: {
                        ...currentProduct.brand,
                        origins: [...currentProduct.brand.origins, res.payload]
                    }
                });
            }
        } else if (leftPanelView === "variety") {
            const res = await createVarietyApi({
                ...data,
                variety_nm: inputValue
            });
            if (res.success) {
                updateCurrentProduct({
                    ...currentProduct,
                    brand: {
                        ...currentProduct.brand,
                        variants: [...currentProduct.brand.variants, res.payload]
                    }
                });
            }
        }
        useAdBlockStore.setState({ leftPanelView: null });
    };

    const handleCancel = () => {
        // Logic to handle cancellation
        setInputValue("");
        useAdBlockStore.setState({ leftPanelView: null });
    };
    
    return <div>
        <LabelledInput
            label="Brand Name"
            value={currentProduct?.brand?.brand_name || ""}
            disabled
        />
        {leftPanelView === "manufacturer" && (
            <LabelledInput
                label="New Manufacturer"
                placeholder="Enter manufacturer name"
                value={inputValue}
                onChange={setInputValue}
            />
        )}
        {leftPanelView === "origin" && (
            <LabelledInput
                label="New Origin"
                placeholder="Enter origin name"
                value={inputValue}
                onChange={setInputValue}
            />
        )}
        {leftPanelView === "variety" && (
            <LabelledInput
                label="New Variety"
                placeholder="Enter variety name"
                value={inputValue}
                onChange={setInputValue}
            />
        )}
        {leftPanelView === "model_number" && (
            <LabelledInput
                label="New Model Number"
                placeholder="Enter model number"
                value={inputValue}
                onChange={setInputValue}
            />
        )}
        <div className="d-flex justify-content-between mt-3">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button onClick={handleSubmit}>Submit</Button>
        </div>
    </div>;
};

export default CreateManufacturerOriginVariety;
